/**
 * Prestudy module barrel export.
 *
 * All routes require authentication. Facility users must log in to
 * view document requests and upload documents.
 *
 * Add to router.tsx under visits/:visitId:
 *   import { prestudyAuthRoutes } from './pages/prestudy'
 *   ...prestudyAuthRoutes,
 */

import type { RouteObject } from 'react-router-dom'
import { CreateLink } from './CreateLink'

export const prestudyAuthRoutes: RouteObject[] = [
  {
    path: 'prestudy',
    children: [
      { path: 'create', element: <CreateLink /> },
    ],
  },
]
